import { render, staticRenderFns } from "./editTncCategory.vue?vue&type=template&id=623591d4&"
import script from "./editTncCategory.vue?vue&type=script&lang=js&"
export * from "./editTncCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports